import { useEffect, useState } from "react"
import "@virtualstate/navigation/polyfill"

export function useLocation() {
	const [location, setLocation] = useState(document.location.href)

	useEffect(() => {
		const listener = (ev: NavigateEvent) => {
			if (!ev.canIntercept || ev.navigationType === 'reload') return
			ev.intercept({
				async handler() {
					//setLocation(document.location.href) // TODO https://github.com/virtualstate/navigation/issues/40
					setLocation(ev.destination.url)
				}
			})
		}

		window.navigation.addEventListener('navigate', listener)
		return () => {
			window.navigation.removeEventListener('navigate', listener)
		}
	})

	return new URL(location)
}
